export default "__VITE_ASSET__CROUk0ao__"